import React,{useState,useEffect,useContext,useRef,createContext} from 'react'
import {Navigate,useNavigate} from 'react-router-dom'
import '../../css/style.css'
import '../../css/SignUp.css'
import '../../css/Login.css'
import Logo from '../../css/images/logo-high3.png'
import {UserContext} from '../../context/UserContext'
//import bgImage from '../../css/images/Signup3.jpg'
import bgImage from '../../css/images/MainBg.png'
import io from 'socket.io-client'
import axios from 'axios'

export default function Login(props) {
  const [success,setSuccess]=useState(0)
  const [msg,setMsg]=useState('')
  const [isLoading,setIsLoading]=useState(true)

  //const {userName,setUserName}=useContext(UserContext)
  const {isAuth,setIsAuth}=useContext(UserContext)
  const {apiToken,setApiToken} = useContext(UserContext)
  const {userID,setUserID }= useContext(UserContext)
  const {usrPhoto,setUsrPhoto}= useContext(UserContext)
  const {firstName,setFirstName,lastName,setLastName}= useContext(UserContext)
  const {sportID,setSportID,langID,setLangID}= useContext(UserContext)
  const {profileIsPublic,setProfileIsPublic}= useContext(UserContext)
  const {usersWhoBlockedMe,setUsersWhoBlockedMe}= useContext(UserContext)
  const {loadUsersWhoBlockedMe}=useContext(UserContext)
  const {socket,setSocket}=useContext(UserContext)
  const {loadUnreadMessages}=useContext(UserContext)
  const { loadUnreadNotifications}=useContext(UserContext)
  const {generalNotifications,setGeneralNotifications}=useContext(UserContext)
  const {setDailyFlames}=useContext(UserContext)


  

  const navigate=useNavigate ()
  const pushTokenRef = useRef(null)
  const [photo,setPhoto]=useState('')
  const [loginObj,setLoginObj]=useState({
    Email:localStorage.getItem('Email') ? localStorage.getItem('Email')  : '',
    Password:localStorage.getItem('Password') ? localStorage.getItem('Password')  : ''
  })



  useEffect(()=>{
    sessionStorage.setItem('scrollY',0)
    if (localStorage.getItem('SportUUID')){
      loadPhoto()
    }else{
      setPhoto(bgImage)
    }

    // Listen for push token sent via postMessage from the native WebView
    const handleMessage = (event) => {
      try {
        const data = JSON.parse(event.data)
        if (data && data.type === 'pushToken') {
          pushTokenRef.current = data.token
        }
      } catch {}
    }
    window.addEventListener('message', handleMessage)

    if (localStorage.getItem('Password')){
      // Wait up to 3 s for the native app to inject the push token before auto-login
      const waitForToken = (attempts = 0) => {
        if (window.expoPushToken) {
          pushTokenRef.current = window.expoPushToken
          sendLogin()
        } else if (attempts < 30) {
          setTimeout(() => waitForToken(attempts + 1), 100)
        } else {
          // Token never arrived — proceed without it
          sendLogin()
        }
      }
      waitForToken()
    }else{
      setIsLoading(false)
    }

    return () => window.removeEventListener('message', handleMessage)
  },[])

  const loadPhoto=()=>{
    

    const uuid=localStorage.getItem('SportUUID')
    const t=123//Date.now()
    setPhoto(process.env.REACT_APP_API_SERVER+'sports/photo/'+uuid+'/'+t)
  }


  const password_show_hide=()=> {
    var x = document.getElementById("floatingPassword");
    var show_eye = document.getElementById("show_eye");
    var hide_eye = document.getElementById("hide_eye");
    hide_eye.classList.remove("d-none");
    if (x.type === "password") {
      x.type = "text";
      show_eye.style.display = "none";
      hide_eye.style.display = "block";
    } else {
      x.type = "password";
      show_eye.style.display = "block";
      hide_eye.style.display = "none";
    }

}

const login=(e)=>{
  e.preventDefault()
  pushTokenRef.current = pushTokenRef.current ?? window.expoPushToken ?? null
  sendLogin()
}

const sendLogin=()=>{
  const pushToken = pushTokenRef.current ?? window.expoPushToken ?? null
  //alert(`Login called with push token: ${pushToken}`)
  loginObj.PushToken=pushToken
  axios.post(process.env.REACT_APP_API_SERVER+'login',loginObj)
  .then(async res=>{
      if (res.data.err==0){
          sessionStorage.setItem('token', res.data.token)

            setApiToken(res.data.token)
            setIsAuth(true)
            setUserID(res.data.uid)
            setUsrPhoto(loadImage(res.data.uid))
            setFirstName(res.data.FirstName)
            setLastName(res.data.LastName)
            setSportID(res.data.SportID)
            setLangID(res.data.LangID)
            setProfileIsPublic(res.data.ProfileIsPublic)
            localStorage.setItem('Email', loginObj.Email)
            localStorage.setItem('Password', loginObj.Password)
            sessionStorage.setItem('WelcomeText',res.data.WelcomeText)
            //console.log(res.data.SportUUID)
            localStorage.setItem('SportUUID', res.data.SportUUID);
            loadUnreadMessages(res.data.uid)
            loadUnreadNotifications(res.data.uid)
            socket.emit('user-connected',res.data.uid)
            setSuccess(1)
            if (res.data.DailyFlames>0){
              setDailyFlames(res.data.DailyFlames)
            }
            if (res.data.ProfileIsUpdated==1){
              navigate('/home')
            }else{
              navigate('/menume')
            }

          
      }else{
        sessionStorage.setItem('token', 'xxxx')

          localStorage.removeItem("Password")
          setIsAuth(false)
          setSuccess(2)
          setMsg(res.data.msg)
          setIsLoading(false)
          
      }

    }).catch(err=>{

      sessionStorage.setItem('token', 'xxxx')

      localStorage.removeItem("Password")
      setIsAuth(false)
      setSuccess(2)
      setIsLoading(false)
  })   
}


const loadImage=(id)=>{
  const d=Date.now()
  //alert(`${process.env.REACT_APP_API_SERVER}files/${userID}/${d}`)
  return(`${process.env.REACT_APP_API_SERVER}files/${id}/${d}`)
}

  return (
    <>
    {!isLoading &&
    <div className="container container-mobile login-page">
        {photo.length>0 &&
            <div className="div-wrap">
                  <div className="box-image">
                    <div className="logo"><img src={Logo} alt=""/></div>
                  </div>
                <div className="form-div">

                  <div className="login-welcome">
                    <h2>Welcome back</h2>
                    <p>Login to continue your journey</p>
                  </div>

                  <div className="login-tab-toggle">
                    <div className="tab-group">
                      <button type="button" className="active">Login</button>
                      <button type="button" onClick={()=>navigate('/signup')}>Sign Up</button>
                    </div>
                  </div>

                  <form onSubmit={login}>
              
                  {props.activate==1 &&
                  
                    <div className="alert alert-danger" role="alert">
                      <b>Please check your email to activate your account.</b>
                    </div>            
                  
                  }

                  {success==2 &&
                    <div className="alert alert-danger mb-3" role="alert">
                    {msg}
                    </div>                  
                  }
                  
                    <div className="login-input-bordered">
                      <i className="bi bi-envelope input-icon-bordered"></i>
                      <input
                        type="email"
                        id="floatingInput"
                        placeholder="Email address"
                        required
                        value={loginObj.Email}
                        onChange={(e)=>setLoginObj({...loginObj,Email:e.target.value})}
                      />
                    </div>

                    <div className="password-input-wrapper">
                      <div className="login-input-bordered">
                        <i className="bi bi-lock input-icon-bordered"></i>
                        <input
                          type="password"
                          id="floatingPassword"
                          placeholder="Password"
                          required
                          value={loginObj.Password}
                          onChange={(e)=>setLoginObj({...loginObj,Password:e.target.value})}
                        />
                      </div>
                      <div className="password-eye-login" onClick={password_show_hide}>
                        <i className="bi bi-eye" id="show_eye"></i>
                        <i className="bi bi-eye-slash d-none" id="hide_eye"></i>
                      </div>
                    </div>

                    <div className="forgot-link">
                      <span onClick={()=>navigate('/forgotpwd')}>Forgot password?</span>
                    </div>

                    <button type="submit" className="login-btn-styled">
                      Login
                      <span className="btn-arrow">→</span>
                    </button>

                    <div className="login-terms-footer">
                      By continuing, you agree to our<br/>
                      <a href="https://onetwothreehigh.com/terms/" target="_blank" rel="noreferrer">Terms of Service</a> and <a href="https://onetwothreehigh.com/privacy/" target="_blank" rel="noreferrer">Privacy Policy</a>
                    </div>

                  </form>				
                </div> 
              </div>
            }
    </div>
    }

    {isLoading &&
           <>
           <br/><br/><br/><br/>
           <div className="home-posts-item">
              <div className="alert alert-secondary" role="alert">
              Loading, please wait...
            </div>
            </div>
            </>
    }

  </>


    


  )
}
